var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/chart-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.535 20.4419H13.6766C12.5216 20.4419 11.5867 21.3768 11.5867 22.5318V31.9185H18.535V20.4419V20.4419Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3956 12.1001H20.6089C19.4539 12.1001 18.5189 13.0351 18.5189 14.1901V31.9002H25.4673V14.1901C25.4673 13.0351 24.5506 12.1001 23.3956 12.1001Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.3382 23.5586H25.4799V31.9004H32.4282V25.6486C32.4099 24.4936 31.4748 23.5586 30.3382 23.5586Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5 40.3332H27.5C36.6666 40.3332 40.3333 36.6665 40.3333 27.4998V16.4998C40.3333 7.33317 36.6666 3.6665 27.5 3.6665H16.5C7.33329 3.6665 3.66663 7.33317 3.66663 16.4998V27.4998C3.66663 36.6665 7.33329 40.3332 16.5 40.3332Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSquare);
export default __webpack_public_path__ + "static/media/chart-square.691048a8746f9983f99c0c4774945908.svg";
export { ForwardRef as ReactComponent };